<template>
    <div class="container-fluid">
        <div class="herosection"
            :style="{
                backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '924px'
            }"
        >
            <NavbarSection />
            <!-- <img src="../assets/images/sports/bookcompetitionoverlay.png" alt="overlay" class="overlay-img" /> -->
            <div class="heroWriteup">
                <p v-html="description"></p>
            </div>
        </div>
    
        <div class="headerContainer" id="club-tournament">
            <h2>Upcoming Tournaments</h2>
            <p>An exciting tournament is coming soon. Stay tuned for dates, fixtures, and updates—don't miss the action</p>
        </div>

        <!-- Search Bar -->
        <div class="search-bar">
            <input v-model="searchQuery" type="text" placeholder="Search for a tournament..." class="search-input" />
        </div>

        <!-- Sports Event Cards -->
        <div class="events-grid">
            <div v-for="event in filteredEvents" :key="event.id" class="event-card">
                <div class="d-flex flex-column align-items-center">
                    <h3>{{ event.name }}</h3>
                </div>
                <!-- <div class="d-flex flex-column align-items-center">
                    <p>{{ event.club_name }}</p>
                </div> -->
                <div class="map-venue">
                    <Trophy />
                    <p><strong>Type: </strong>{{ event.type }}</p>
                </div>
                <div class="map-venue">
                    <List />
                    <p> <strong>Category: </strong> {{ event.category }}</p>
                </div>
                <div class="map-venue">
                    <MapPin />
                    <p><strong>Location:</strong> {{ event.location }}</p>
                </div>
                <p style="margin-top: 10px; margin-bottom: 10px;">{{ event.description }}</p>
                <div class="map-venue">
                    <Calendar />
                    <p> <strong>Start:</strong> {{ event.start_date }} - <strong>End:</strong> {{ event.end_date }} </p>
                </div>
                <div class="map-venue">
                    <Clock />
                    <p> <strong>Deadline:</strong> {{ event.registration_deadline }} </p>
                </div>
                <div class="map-venue">
                    <UsersRound />
                    <p> <strong>Slot:</strong> {{ event.slot }}</p>
                </div>
                <div class="map-venue">
                    <User />
                    <p><strong>Age:</strong> {{ event.age_limits ? event.age_limits : "NILL" }}</p>
                </div>
                <button @click="goToRegistration(filteredEvents)">Register</button>
            </div>
        </div>
        <!-- <div class="see-all">
            <button class="see-all-event">
                <p>See All Events</p>
                <MoveRight />
            </button>
        </div> -->
        <!-- Tournament Registration Modal -->
        <div class="modal fade" id="tournamentModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 class="modal-title">Tournament Event Registration</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <!-- Registration Form -->
                    <form id="tournamentForm">
                        <div class="modal-body text-start">
                            <!-- Personal Information Section -->
                            <div class="mb-4">
                                <h6 class="border-bottom pb-2 mb-3">Personal Information</h6>
                                
                                <!-- Full Name -->
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label class="form-label">First Name <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" v-model="firstName" required placeholder="Enter first name">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Last Name <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" v-model="lastName" required placeholder="Enter last name">
                                    </div>
                                </div>

                                <!-- Gender and Age -->
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label class="form-label">Gender <span class="text-danger">*</span></label>
                                        <select class="form-select" v-model="gender" required>
                                            <option value="">Select gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Age <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" v-model="age" required min="1" max="100" placeholder="Enter age">
                                    </div>
                                </div>

                                <!-- Contact Information -->
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                                        <input type="tel" class="form-control" v-model="phoneNumber" required placeholder="Enter phone number">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Email Address <span class="text-danger">*</span></label>
                                        <input type="email" class="form-control" v-model="emailAddress" required placeholder="Enter email address">
                                    </div>
                                </div>

                                <!-- Club Name -->
                                <div class="mb-3">
                                    <label class="form-label">Club Name <span class="text-danger">*</span></label>
                                    <select id="category" class="form-control" required v-model="clubName">
                                        <option disabled value="">-- Select club --</option>
                                        <option v-for="(data, index) in dataListClub" :key="index" :value="data.id">{{ data.club_name }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Terms and Conditions -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="agreeTerms" id="agreeTerms" required>
                                    <label class="form-check-label" for="agreeTerms">
                                        I agree to the <a href="/terms-and-conditions" target="_blank">terms and conditions</a> and understand the tournament rules
                                    </label>
                                </div>
                            </div>

                            <!-- Payment Notice -->
                            <div class="alert alert-info mb-0">
                                <div class="d-flex">
                                    <div class="flex-shrink-0">
                                        <i class="bi bi-info-circle"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <strong>Registration Fee:</strong> {{ registrationFee }}<br>
                                        <strong>Payment Method:</strong> Paystack (Card, Bank Transfer, USSD)<br>
                                        <small class="text-muted">Registration is only confirmed after successful payment</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Modal Footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success" @click="payWithPaystack()" :disabled="!agreeTerms">
                                Continue - {{ registrationFee }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <ReusableAccordion />

        <FooterSection />
    </div>
</template>


<script setup>
/* eslint-disable */
import { ref, onMounted, computed } from 'vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ReusableAccordion from '@/components/ReusableAccordion.vue';
import { Calendar, 
  MapPin, 
  UsersRound, 
  Trophy, 
  Building, 
  List, 
  User, 
  Clock } from 'lucide-vue-next';
//import eventimage from "../assets/images/sports/eventimage.jpg"
import axios from 'axios';
import PaystackPop from '@paystack/inline-js';
import router from "@/router";
import { Modal } from 'bootstrap';

const searchQuery = ref('');
const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');
const sportsEvents = ref([]);
const loggedId = ref(localStorage.getItem('userid'));
const tournamentType = ref('');
const junior_category = ref('')
const participant = ref('')
const team = ref('')
const email_address = ref(localStorage.getItem('email_address'));
const event_fees = ref([])
const event_status = ref([])
const registrationFee = ref('')
const firstName = ref('')
const lastName = ref('')
const gender = ref('')
const age = ref('')
const phoneNumber = ref('')
const emailAddress = ref('')
const clubName = ref('')
const tournamentData = ref([])
const agreeTerms = ref('')
const dataListClub = ref([])

const filteredEvents = computed(() => {
    return sportsEvents.value.filter((event) =>
        event.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
});
let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
  await listBanner()
  await listClubRecords()
});


const listBanner = async () => {
  try {
    const config = 'tournament';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listClubRecords = async () => {
  try {
    const response = await axios.get('/club_lists.php', { });
    if (response.data.status) dataListClub.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

onMounted(async () => {
        await listRecords()
});
  
const listRecords = async () => {
    try {
    const response = await axios.get('/tournament_lists_six.php', { });
    if (response.data.status) sportsEvents.value = response.data.data;
    else console.error(response.data.message);
    } catch (error) {
    console.error(error.message);
    }
};

const goToRegistration = (card) => {

    // if user not logged in
    if (!loggedId.value) {
        router.push('/login/registerTournament');
        return;
    }
    registrationFee.value = card[0].entry_fee
    tournamentData.value = card

    // open registration modal
    const modal = new Modal(document.getElementById('tournamentModal'));
    modal.show();
};

const payWithPaystack = () => {

    if (!firstName.value || !lastName.value || !gender.value || !age.value || !phoneNumber.value || !emailAddress.value || !clubName.value) {
    alert('Please all fields are important');
    return;
    }


    if (!email_address.value) {
        alert('Your email address is missing. Please update your email address.');
        return;
    }

    const tournament = tournamentData.value?.[0];

    if (!tournament) {
        alert('Tournament data not available');
        return;
    }

    // REGISTRATION DEADLINE CHECK
    if (!isRegistrationOpen(tournament.registration_deadline)) {
        alert('Registration for this tournament has closed');
        return;
    }

    // AGE VALIDATION
    if (!isAgeAllowed(Number(age.value), tournament.age_limits)) {
        alert(`Your age does not meet the requirement for this tournament (${tournament.age_limits})`);
        return;
    }

    // SLOT VALIDATION
    if (!hasAvailableSlot(tournament.slot, tournament.registered_count)) {
        alert('This tournament is already full. No slots available.');
        return;
    }

    const paystack = new PaystackPop();

    paystack.newTransaction({
        key: process.env.VUE_APP_PAYSTACK_LIVE_KEY,
        email: email_address.value,
        amount: Number(registrationFee.value) * 100,

        onSuccess: (transaction) => { 
            // Payment complete! Reference: transaction.reference 
            const payment_ref = transaction.reference 
            createPayment(tournamentData.value[0], registrationFee.value, payment_ref)
        },
        onCancel: () => {
            // user closed popup
        }
    });
}

const createPayment = async (data, registration_fee, reference) => {
try {
    const response = await axios.post('/tournament_payment.php', { user_id: loggedId.value, tournament_id: data.id, amount: registration_fee, description: reference, user_email: email_address.value, payment_status: 'program-booking', firstname: firstName.value, lastname: lastName.value, gender: gender.value, age: age.value, phone: phoneNumber.value, email: emailAddress.value, club: clubName.value, terms: agreeTerms.value, data });
    if (response.data.status) {
        alert(response.data.message) 
        window.location.reload();
    }
        else console.error(response.data.message);
    } catch (error) {
        alert(error.response ? error.response.data.message : error.message);
        console.error('Error:', error.response ? error.response.data : error.message);
    }
};
const isAgeAllowed = (age, ageLimits) => {
    if (!ageLimits) return true;

    // 18-35
    const range = ageLimits.match(/^(\d+)\s*-\s*(\d+)$/);
    if (range) {
        return age >= Number(range[1]) && age <= Number(range[2]);
    }

    // 18+
    const plus = ageLimits.match(/^(\d+)\+$/);
    if (plus) {
        return age >= Number(plus[1]);
    }

    // U18
    const under = ageLimits.match(/^U(\d+)$/i);
    if (under) {
        return age < Number(under[1]);
    }

    return true;
};

const isRegistrationOpen = (deadline) => {
    if (!deadline) return true;
    const today = new Date();
    const regDeadline = new Date(deadline);
    return today <= regDeadline;
};

const hasAvailableSlot = (slot, registeredCount) => {
    if (!slot) return true;
    return Number(registeredCount) < Number(slot);
};


</script>


<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/sports/bookcompetition.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}
.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}

.heroWriteup {
        position: absolute;
        max-width: 650px;
        text-align: left;
        bottom: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 52px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        button {
            background-color: #F3F4F6;
            width: 296px;
            height: 64px;
            border-radius: 40px;
            border: 4px solid #ED4E241A;
            margin-top: 2rem
        }
}


.map-venue {
    display: flex;
    justify-content: start;
    align-items: start;
    gap: 10px;
    margin-top: 10px;
    color: #fff;
}

.search-bar {
    display: flex;
    justify-content: center;
    margin: 2rem 0;

    .search-input {
        width: 100%;
        max-width: 400px;
        padding: 10px 15px;
        border: 2px solid #ddd;
        border-radius: 30px;
        font-size: 16px;
        outline: none;
        transition: border-color 0.3s ease;

        &:focus {
            border-color: #ed4e24;
        }
    }
}

/* Events Grid */
.events-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    padding: 20px;
    max-width: 1240px;
    margin: auto;

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }

    .event-card {
        background: #072a08;
        color: #fff !important;
        border-radius: 28px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        padding: 14px;
        text-align: center;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 1px solid #E7E7E7;

        img {
            width: 100%;
            object-fit: cover;
            border-radius: 22px;
            margin-bottom: 15px;
        }

        h3 {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
            text-align: left;
        }

        p {
            font-size: 14px;
            color: #fff;
            margin-bottom: 5px;
            text-align: left;
            font-weight: 400;
        }

        button {
            width: 100%;
            border-radius: 50px;
            background-color: #ED4E24;
            height: 52px;
            margin-top: 20px;
            border: 4px solid #E306132B;
            color: white;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
        }
    }
}

.headerContainer {
    width: 100%;
    margin-top: 30px;

    h2 {
        font-size: 52px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000;
    }

    p {
        font-size: 18px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000CC;
    }
}


.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.5);
    /* black with 40% opacity */
    z-index: 1;
}


.pioneers-section {
    margin-top: 5rem;

    h2 {
        font-size: 48px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        margin-bottom: 4rem;
    }
}

.see-all {
    width: 70%;
    margin: auto;
    display: flex;
    justify-content: end;
    align-items: end;

}

.see-all-event {
    background-color: transparent;
    color: #ED4E24;
    display: flex;
    border: none;
    justify-content: center;
    align-items: center;
    gap: 10px;

    p {
        margin: 0%;
        padding: 0%;
    }
}


@media (max-width: 768px) {

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }

    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 90%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #ffffff;
                border: 2px solid #0000001f;
                color: black;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }
}
</style>
